import { render, staticRenderFns } from "./UsersPanel.vue?vue&type=template&id=28fccbe5&scoped=true&"
import script from "./UsersPanel.vue?vue&type=script&lang=js&"
export * from "./UsersPanel.vue?vue&type=script&lang=js&"
import style0 from "./UsersPanel.vue?vue&type=style&index=0&id=28fccbe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fccbe5",
  null
  
)

export default component.exports